// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-datetime-field';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.192 12.96H1.656a1.137 1.137 0 0 1-1.152-1.152v-9c0-.648.504-1.152 1.152-1.152h10.152c.648 0 1.152.504 1.152 1.152v3.384M.576 5.04H12.96m-9-2.232V.576m5.616 2.232V.576' />
    <path d='M8.424 12.96c0 2.52 2.016 4.464 4.464 4.464s4.464-2.016 4.464-4.464-2.016-4.464-4.464-4.464-4.464 1.944-4.464 4.464z' />
    <path d='M14.904 12.96H12.96v-2.016' />
  </g>
);

export const viewBox = '0 0 18 18';
